module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"activity":"Activity","search":"Search","no":"No.","task_name":"Task Name","progress":"Progress","duration":"Duration","predecessor":"Predecessor","create_task":"Create task"},"th":{"activity":"กิจกรรม","search":"ค้นหา","no":"เลขที่","task_name":"ชื่องาน","progress":"ความคืบหน้า","duration":"ระยะเวลา","predecessor":"Predecessor","create_task":"สร้าง task"}}')
  delete Component.options._Ctor
}
